import printMailingPreference from 'account/myPreferences/printMailingPreference';

if (document.querySelector('.print-mailing-preference')) {
	printMailingPreference();
}
